import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { action, computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { IGridProps } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models';
import { IDataRow } from '../../../models/IDataRow';
import { ICommonData } from '../../../models/ICommonData';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
	}

	@computed
	get hasData(): boolean {
		// TODO: Each Application should put custom show logic here: "return this.storeContext[component store].hasData;"
		return true;
	}

	@action
	contextsDidUpdateAfter = async () => {
		// TODO: Each Application should put custom logic here to handle changes to the data context
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get cardProps(): ICardProps | undefined {
		const cardProps = this.appComponentConfiguration && this.appComponentConfiguration.cardProps;
		return this.mergeQueriesAndProps(cardProps);
	}

	@computed
	get gridProps(): IGridProps | undefined {
		return this.appComponentConfiguration && this.appComponentConfiguration.gridProps;
	}

	@computed
	get commonData(): ICommonData | undefined {
		return (this.configuration && this.configuration.commonData) || {};
	}

	@computed
	get rawData(): IDataRow[] {
		const dataQuery = this.commonData && this.commonData.data;
		if (dataQuery) {
			const data = this.getQueryValue(dataQuery);
			if (data) {
				return data;
			}
		}
		return [];
	}

	getData = (componentCommonData: ICommonData | undefined): IDataRow[] => {
		const options = { ...this.commonData, ...(componentCommonData || {}) };
		const {
			nameKey = 'label',
			xKey = 'value',
			yKey = 'value',
			colorKey = 'color',
			shapeKey = 'shape',
			nameQuery,
			xQuery,
			yQuery,
			colorQuery,
			shapeQuery,
		} = options;
		const data = this.rawData;
		if (data) {
			return data.map((row: any) => {
				return {
					...row,
					name: nameQuery ? this.getQueryValue(nameQuery, row) : row[nameKey],
					x: xQuery ? this.getQueryValue(xQuery, row) : row[xKey],
					y: yQuery ? this.getQueryValue(yQuery, row) : row[yKey],
					color: colorQuery ? this.getQueryValue(colorQuery, row) : row[colorKey],
					shape: shapeQuery ? this.getQueryValue(shapeQuery, row) : row[shapeKey],
				} as IDataRow;
			});
		}
		return [];
	}

	getColors = (data: IDataRow[], componentCommonData: ICommonData | undefined) => {
		const options = { ...this.commonData, ...(componentCommonData || {}) };
		const dataHasColor = data.find(row => !!row.color);
		const colors = dataHasColor ? data.map(row => row.color || '') : options.colors;
		return colors;
	}

	async customInitializeAfter() {

	}
}